import { render, staticRenderFns } from "./ManageContent.vue?vue&type=template&id=097ca7a0&"
import script from "./ManageContent.vue?vue&type=script&lang=js&"
export * from "./ManageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('097ca7a0')) {
      api.createRecord('097ca7a0', component.options)
    } else {
      api.reload('097ca7a0', component.options)
    }
    module.hot.accept("./ManageContent.vue?vue&type=template&id=097ca7a0&", function () {
      api.rerender('097ca7a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/ManageContent.vue"
export default component.exports